
import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout'

import Providers from '@/pages/Providers'
import ProviderDetails from '@/pages/Providers/ProviderDetails'
import ModifyProvider from '@/pages/Providers/modifyProvider'
import AccountReport from '@/pages/Providers/AccountReport/index'
import WizardProvider from '@/pages/Providers/WizardProvider'

const providerPages = {
  path: '/',
  component: DashboardLayout,
  name: 'providerPages',
  title: 'Proveedores',
  icon: 'supervised_user_circle',
  meta: {
    ifUserCan: {
      view: 'Provider/provider',
    },
  },
  excludedGroups: [ 'Extranet' ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/providers',
      name: 'Listado proveedores',
      title: 'Listado proveedores',
      meta: {
        ifUserCan: {
          view: 'Provider/provider',
        },
      },
      component: Providers,
    },
    {
      path: '/provider/wizard',
      name: 'Registrar proveedor',
      title: 'Registrar proveedor',
      component: WizardProvider,
      meta: {
        ifUserCan: {
          add: 'Provider/provider',
        },
      },
    },
    {
      path: '/proveedores/cuentas-de-proveedor',
      name: 'Cuentas de proveedor',
      title: 'Cuentas de proveedor',
      component: AccountReport,
      roles: ["ADMIN"],
      meta: {
        ifUserCan: {
          view: 'Provider/provider',
        },
      },
    },
    {
      path: '/provider/:id',
      name: 'Ficha de proveedor',
      component: ProviderDetails,
      meta: {
        ifUserCan: {
          view: 'Provider/provider',
        },
      },
    },
    {
      path: '/provider/editar/:id',
      name: 'Modificar proveedor',
      component: ModifyProvider,
      meta: {
        ifUserCan: {
          change: 'Provider/provider',
        },
      },
    },
  ],
}


export default providerPages



// WEBPACK FOOTER //
// ./src/router/providerRoutes.js